export const refundRuleList = [
  {label: '支持7天无理由退货', value: 1},
  {label: '可协商退款', value: 2},
  {label: '可协商退款', value: 3},
  {label: '不支持7天无理由退货', value: 4},
  {label: '支持7天无理由退货(拆封后不支持)', value: 5},
  {label: '支持7天无理由退货(激活后不支持)', value: 6},
  {label: '支持7天无理由退货(安装后不支持)', value: 7},
  {label: '支持7天无理由退货(定制类不支持)', value: 8},
  {label: '支持7天无理由退货(使用后不支持)', value: 9},
  {label: '支持7天无理由退货(开窗后不支持)', value: 10}
]